import { render, staticRenderFns } from "./LaudoDiagnosticoAgricola.vue?vue&type=template&id=4b364964&scoped=true&lang=pug"
import script from "./LaudoDiagnosticoAgricola.vue?vue&type=script&lang=js"
export * from "./LaudoDiagnosticoAgricola.vue?vue&type=script&lang=js"
import style0 from "./LaudoDiagnosticoAgricola.vue?vue&type=style&index=0&id=4b364964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b364964",
  null
  
)

export default component.exports